import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexto/AuthContext";
import PrivateRoute from "./componentes/auxiliares/PrivateRoute";
import PublicRoute from "./componentes/auxiliares/PublicRoute";
import Home from "./paginas/Home";
import Login from "./paginas/Login";
import Dashboard from "./paginas/Dashboard";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        // main: "#C0DB1A",
        main: "#71c160",
      },
      secondary: {
        // main: "#B3B8BB",
        main: "#2F4F4F",
      },
      error: {
        main: "#f44336", // Rojo
      },
      warning: {
        main: "#ffa726", // Naranja
      },
      info: {
        main: "#2196f3", // Azul claro (por defecto)
        light: "#6ec6ff",
        dark: "#0069c0",
        contrastText: "#ffffff",
      },
      success: {
        main: "#4caf50", // Verde
      },
      background: {
        secondary: "rgba(188, 189, 192, 0.8)", // Definir en background para más flexibilidad
      },
    },
    components: {
      MuiGrid: {
        styleOverrides: {
          root: {
            paddingTop: "2rem",
            // Aplica paddingTop solo para xs
            "@media (max-width:600px)": {
              paddingTop: "1rem", // Aplica el paddingTop con !important solo en pantallas xs
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        },
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Esto aplica estilos globales de MUI */}
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
